import { useParams } from 'react-router-dom';
import { Commission, User } from '../types/types';
import commissionData from '../data/partialData.json';
import userData from '../data/userData.json';
import styles from './ProfilePage.module.css';

function ProfilePage() {
  type ProfilePageParams = {
    userId: string;
  }

  // get user with userId
  const {userId} = useParams<ProfilePageParams>();
  const user: User = userData.users.filter((u) => u.id === userId)[0];

  // get all commissions by the user
  const commissions: Commission[] = commissionData.commissions.filter(
    (c) => c.artistId === userId && ["Done", "Awaiting Payment"].includes(c.status));

  const ArtworksContainer = () => {
    return (
      <div className={styles.artworks}>
        {commissions.map(
          (commission) => <img 
                            key={commission.id} 
                            className={styles.artworkPreview} 
                            src={commission.imageUrls[0]} 
                            alt="commission" />
        )}
      </div>
    );
  }

  const ProfileContainer = () => {
    if (user) {
      return (
        <div>
        <div className={styles.profilePage}>
          <h2 className={styles.title}>{user.id}'s Art Page</h2>

          <div className={styles.statusSection}>
            <img className={styles.avatar} src={user.avatarUrl} alt="avatar"></img>
            <p className={styles.label}>Commission Status: {user.isCommissionOpen ? "Open" : "Closed"}</p>
            <p>{user.about}</p>
            <p>{user.contactInfo}</p>
          </div>
          </div>

          <div className={styles.artworksContainer}>
            <p className={styles.label}>Completed Commissions</p>
            {ArtworksContainer()}
          </div>
        </div>
      );
    }
    return (
      <div>
        <h2>Oops! The user {userId} does not exist ;w;</h2>
      </div>
    )
  }

  return (
    <div>
      {ProfileContainer()}
    </div>
  );
}

export default ProfilePage;